export default __webpack_public_path__ + "static/media/thumbGreen.6d42affa.svg";